<template>
  <div class="algodep-menu">
    <div class="algodep-content">
      <div class="algodep-menubox">
        <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">首頁</div>
        <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">
          業務領域
        </div>
        <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">
          關於我們
        </div>
        <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">
          聯系我們
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "aboutUs" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;
        case 4:
          this.$router.push({ path: "projects" });
          break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.algodep-menu {
  position: absolute;
  top: 60px;
  left: 360px;
  z-index: 99;
  width: 1200px;

  .algodep-content {
    position: relative;
    background-image: url(../assets/menuImg.png);
    height: 84px;
    background-size: 100% 100%;
    position: relative;
  }

  .algodep-menubox {
    position: absolute;
    top: 26px;
    left: 62px;
    display: flex;
    align-items: center;
    font-size: 20px;
    font-family: ArialMT;
    color: #333333;
    cursor: pointer;

    div {
      margin-right: 64px;
    }
  }

  .select {
    font-weight: 600;
    color: #2C85FA;
  }
}
</style>
